/* eslint-disable */
import React, { Fragment } from 'react'
import Logo from '../../components/Logo'

export default ({children}) => (
	<Fragment>
		<header id='home'>
			<div className="header__bg"></div>
			<div className="content-wrap">
				<Logo />
			</div>
			<div className="content-wrap">
				<h1>How Do Your Facebook<br />Ads Stack Up?</h1>
				<p className="subtext">See how you compare to nearly $4 billion of social advertising investments.</p>
			</div>
			<div className="content-wrap">
				{children}
			</div>
		</header>
		<footer>
			<a href="https://unified.com/privacy-policy">Privacy Policy</a><span>| ©2018 Unified Enterprise Corp.</span>
  </footer>
	</Fragment>
)


// WEBPACK FOOTER //
// ./src/containers/Home/wrapper.js